<svg role="img" [attr.aria-label]="label ? label : null" [attr.aria-hidden]="label ? null : 'true'" focusable="false">
  <use attr.xlink:href="/assets/icons/symbol-defs.svg#{{ icon }}" />
</svg>
